/**
 * Prepends value added required to the value added api and the slot api call
 * @param product
 * @returns string[]
 */

export function prependedValueAdded(product) {
  let preprendedVaps: string[] = [];
  const additiveLineCode = product['additiveLine'];
  const additionLineCode = product['additionLine'];
  // Order it (Additive 1st, Addition 2nd)
  preprendedVaps = [additiveLineCode, additionLineCode];
  return preprendedVaps.filter((_) => !!_);
}
